var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAndorra(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_7079)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.696 486.598C178.352 502.872 216.109 512 256 512C295.891 512 333.648 502.872 367.304 486.598L389.565 256L367.304 25.402C333.648 9.128 295.891 0 256 0C216.109 0 178.352 9.128 144.696 25.402L122.435 256L144.696 486.598Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.304 486.589C452.935 445.183 512 357.493 512 256C512 154.507 452.935 66.8171 367.304 25.4111V486.589Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.696 486.589V25.4111C59.065 66.8171 0 154.506 0 256C0 357.494 59.065 445.183 144.696 486.589Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 345.043C256 304.192 256 256 256 256H322.783V289.391C322.783 295.192 311.653 316.448 284.18 333.913C273.775 340.529 263.004 342.657 256 345.043Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.217 189.217H256V256H189.217V189.217Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.391 166.957C289.391 154.662 279.424 144.696 267.13 144.696C263.07 144.696 259.276 145.8 256 147.698C252.723 145.8 248.93 144.696 244.87 144.696C232.576 144.696 222.609 154.662 222.609 166.957H166.957V278.26C166.957 319.696 199.863 343.659 225.668 356.081C223.737 359.379 222.609 363.206 222.609 367.305C222.609 379.6 232.576 389.566 244.87 389.566C248.93 389.566 252.724 388.462 256 386.564C259.277 388.462 263.07 389.566 267.13 389.566C279.424 389.566 289.391 379.6 289.391 367.305C289.391 363.206 288.263 359.379 286.331 356.081C312.136 343.659 345.043 319.697 345.043 278.26V166.957H289.391ZM311.652 278.26C311.652 284.061 311.652 301.712 284.18 319.178C273.774 325.794 263.004 330.084 256 332.469C248.996 330.084 238.226 325.794 227.82 319.178C200.348 301.712 200.348 284.061 200.348 278.26V200.348H311.652V278.26Z",
    fill: "#FF9811"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_7079"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndorra);
export default __webpack_public_path__ + "static/media/andorra.6bfbbc05749408b634c0ef0106b83ad2.svg";
export { ForwardRef as ReactComponent };